import { oz } from '@weft/utils';
import { INTEGRATION_PROVIDERS } from '../integration-providers-schema';
import { HubspotIntegrationConfigurationSchema } from './hubspot-integration-configuration';

export const HubspotIntegrationSettingsSchema = oz.object({
  integrationProvider: oz.literal(INTEGRATION_PROVIDERS.hubspot),
  integrationConfiguration: HubspotIntegrationConfigurationSchema,
}).openapi('HubspotIntegrationSettings');

export type HubspotIntegrationSettings = oz.infer<typeof HubspotIntegrationSettingsSchema>;